export default __webpack_public_path__ + "images/53cd1de1c46f0cb84ed3d03ea30ca7c5-reggae_small.webp";